exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-78e4c258]{-webkit-tap-highlight-color:transparent}.app-wrapper[data-v-78e4c258]{height:100%;overflow-y:auto;overflow-x:hidden;overscroll-behavior:none;overscroll-behavior-y:none;-webkit-overscroll-behavior:none}.wrapper-center[data-v-78e4c258]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78e4c258","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/Layout.vue
// module id = yMI1
// module chunks = 76